module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/join-1-1bbf1fae3a7a9f173842ff005d61764b.svg";